// extracted by mini-css-extract-plugin
export default {"main":"EditAcknowledgement_main__rB-XE","actions":"EditAcknowledgement_actions__-n-Iz","textAreaHeight":"EditAcknowledgement_textAreaHeight__ZrPun"};